import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs';
import { siteSpecificData } from '../../../environments/site-specific-data';
import { User } from '../models/user';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { UserInviteRequest } from '../models/user-invite-request';
import { UserInviteResult } from '../models/user-invite-result';
import { UserDisableRequest } from '../models/user-disable-request';
import { UserSettingsService } from '@user-settings/services/user-settings.service';

const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class UserService {

  constructor(
    private http: HttpClient,
    private readonly urlBuilder: UrlBuilderService,
    private readonly userSettingsService: UserSettingsService
  ) { }

  isUserNameAvailable(userName: string): Observable<boolean> {
    const userNameAvailableUrl = this.urlBuilder.getUrl('account/available');
    const params = new HttpParams().set('userName', userName);
    return this
      .http
      .get<boolean>(userNameAvailableUrl, { params: params });
  }

  getAllUsers(): Observable<User[]> {

    const usersUrl = this.urlBuilder.getIdentityServerUrl('mciuseradmin/getusers');

    return this.userSettingsService.getUserSettings().pipe(
      switchMap(us => {
        const params = new HttpParams().set('callerMojoPlatformUserId', us.MojoPlatformUserId.toString());
        return this
          .http
          .get<User[]>(usersUrl, { params: params })
          .pipe();
      }));

  }

  // TODO: Why is this still here?
  inviteUser(user: User): Observable<string> {
    const inviteUrl = `${API_URL}account/invite`;
    const result = this
      .http
      .post(inviteUrl, user, { responseType: 'text' });
    return result;
  }

  inviteUsers(users: UserInviteRequest[], brand: string): Observable<UserInviteResult[]> {
    const inviteUrl = this.urlBuilder.getIdentityServerUrl('mciuseradmin/sendpasswordreset');

    return this.userSettingsService.getUserSettings().pipe(

      switchMap(us => {

        const body = {
          CallerMojoPlatformUserId: us.MojoPlatformUserId.toString(),
          UsersToInvite: users,
          BrandId: brand
        };

        const result = this
          .http
          .post<UserInviteResult[]>(inviteUrl, body );

        return result;

      }));

  }

  disableUsers(users: UserDisableRequest[]): Observable<UserInviteResult[]> {
    const url = this.urlBuilder.getIdentityServerUrl('mciuseradmin/disableusers');

    return this.userSettingsService.getUserSettings().pipe(
      switchMap(us => {
        const body = {
          CallerMojoPlatformUserId: us.MojoPlatformUserId.toString(),
          UsersToDisable: users,
        }
        const result = this
          .http
          .request<UserInviteResult[]>('delete', url, { body: body });
        return result;
      }));

  }


  createUser(user: User): Observable<UserInviteResult> {
    const usersUrl = this.urlBuilder.getIdentityServerUrl('mciuseradmin/createuser');

    return this.userSettingsService.getUserSettings().pipe(
      switchMap(us => {

        const body = {
          CallerMojoPlatformUserId: us.MojoPlatformUserId.toString(),
          UserToCreate: user,
        }

        const result = this
          .http
          .post<UserInviteResult>(usersUrl, body);

        return result;

      }));

  }

  updateUser(user: User): Observable<UserInviteResult> {
    const usersUrl = this.urlBuilder.getIdentityServerUrl('mciuseradmin/updateuser');

    return this.userSettingsService.getUserSettings().pipe(
      switchMap(us => {

        const body = {
          CallerMojoPlatformUserId: us.MojoPlatformUserId.toString(),
          UserToUpdate: user,
        }

        const result = this
          .http
          .post<UserInviteResult>(usersUrl, body);

        return result;

      }));

  }

  // TODO: Why is this still here?
  deleteUser(user: User): Observable<string> {
    const usersUrl = `${API_URL}users/` + user.id;

    const result = this
      .http
      .delete(usersUrl, { responseType: 'text' });

    return result;
  }

  // TODO: Why is this still here?
  disableUser(user: User): Observable<string> {
    const accountUrl = `${API_URL}account/disable`;

    const result = this
      .http
      .post(accountUrl, user, { responseType: 'text' });

    return result;
  }

}
